import(/* webpackMode: "eager" */ "/vercel/path0/thomas-gia/src/app/page.tsx")